import { render, staticRenderFns } from "./UserActivityTable.vue?vue&type=template&id=3f76cb34&scoped=true&"
import script from "./UserActivityTable.vue?vue&type=script&lang=js&"
export * from "./UserActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityTable.vue?vue&type=style&index=0&id=3f76cb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76cb34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f76cb34')) {
      api.createRecord('3f76cb34', component.options)
    } else {
      api.reload('3f76cb34', component.options)
    }
    module.hot.accept("./UserActivityTable.vue?vue&type=template&id=3f76cb34&scoped=true&", function () {
      api.rerender('3f76cb34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userActivity/components/UserActivityTable.vue"
export default component.exports